import { NavLink, useNavigate } from "react-router-dom";
import { HomeIcon, TagIcon, UsersIcon, CogIcon, MenuIcon, LogoutIcon } from "@heroicons/react/solid";
import { safeGetJSON } from "../../utils/storage";
import { useAuth } from "../../hooks/useAuth";

export default function OwnerSidebar({ collapsed, onToggle }) {
  // user name (optional)
  const user = safeGetJSON("user") || {};
  const name = user.name || "Owner";
  const navigate = useNavigate();
  const { logout } = useAuth();

  const linkClass = (isActive) =>
    `flex items-center gap-3 px-4 py-3 rounded-xl ${
      isActive
        ? "bg-gradient-to-r from-blue-500/90 to-indigo-500/90 text-white shadow-lg"
        : "text-white/80 hover:bg-white/10"
    } ${collapsed ? "justify-center" : ""}`;

  return (
    <aside
      className={`hidden bg-gradient-to-b from-slate-950 via-slate-900 to-blue-900 text-white transition-all lg:flex ${
        collapsed ? "w-16" : "w-64"
      } flex-shrink-0 border-r border-white/10`}
    >
      <div className="h-full flex flex-col">
        <div className="px-4 py-5 flex items-center justify-between">
          {!collapsed ? (
            <div className="flex items-center gap-3">
              <div className="bg-white text-slate-900 rounded-full w-10 h-10 flex items-center justify-center font-bold shadow-lg">
                AJ
              </div>
              <div>
                <div className="text-lg font-bold tracking-tight">AbroadJacks</div>
                <div className="text-xs text-white/70 tracking-[4px] uppercase">
                  Owner Panel
                </div>
              </div>
            </div>
          ) : (
            <div className="flex items-center justify-center w-full">
              <div className="bg-white rounded-full w-10 h-10 flex items-center justify-center text-slate-900 font-bold">
                AJ
              </div>
            </div>
          )}

          <button onClick={onToggle} className="ml-2 p-1 hover:bg-white/10 rounded">
            <MenuIcon className="h-5 w-5" />
          </button>
        </div>

        <nav className="mt-4 px-2 space-y-2 flex-1">
          <NavLink to="/owner/dashboard" className={({ isActive }) => linkClass(isActive)}>
            <HomeIcon className="h-5 w-5" /> {!collapsed && <span>Dashboard</span>}
          </NavLink>

          <NavLink to="/owner/add-offer" className={({ isActive }) => linkClass(isActive)}>
            <TagIcon className="h-5 w-5" /> {!collapsed && <span>Offers Lab</span>}
          </NavLink>

          <NavLink to="/owner/leads" className={({ isActive }) => linkClass(isActive)}>
            <UsersIcon className="h-5 w-5" /> {!collapsed && <span>Leads</span>}
          </NavLink>

          <NavLink to="/owner/settings" className={({ isActive }) => linkClass(isActive)}>
            <CogIcon className="h-5 w-5" /> {!collapsed && <span>Settings</span>}
          </NavLink>
        </nav>

        <div className="p-4">
          <button
            onClick={() => {
              logout();
              navigate("/", { replace: true });
            }}
            className="w-full flex items-center gap-3 justify-center bg-gradient-to-r from-rose-500 to-red-500 hover:opacity-90 text-white px-3 py-2 rounded-xl shadow-lg"
          >
            <LogoutIcon className="h-4 w-4" /> {!collapsed && <span>Logout</span>}
          </button>

          {!collapsed && (
            <div className="mt-4 text-sm text-white/80">
              Signed in as <div className="font-semibold mt-1">{name}</div>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
}
